import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n          animation: ", " 0.2s ease-out;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 4px;\n  background-color: ", ";\n  position: absolute;\n  bottom: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  0%   { transform: scaleX(0);  opacity: 0.5; }\n  100% { transform: scaleX(1);  opacity: 1;   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { ADVENTURE_GREEN } from '../../colors';
import { getPx } from '../../helpers/common';
import { useVariable } from '../../hooks';
var appear = keyframes(_templateObject());
var Line = styled.div(_templateObject2(), ADVENTURE_GREEN, function (_ref) {
  var $withTransition = _ref.$withTransition;
  return $withTransition ? "\n        transition: left 0.3s ease-in-out, width 0.3s ease-in-out;\n      " : '';
}, function (_ref2) {
  var $left = _ref2.$left;
  return "left: " + getPx($left) + ";";
}, function (_ref3) {
  var $width = _ref3.$width;
  return "width: " + getPx($width) + ";";
}, function (_ref4) {
  var $animate = _ref4.$animate;
  return $animate ? css(_templateObject3(), appear) : '';
});

var TabLine = function TabLine(_ref5) {
  var onLineReset = _ref5.onLineReset,
      refCurrent = _ref5.refCurrent,
      refCurrentInner = _ref5.refCurrentInner,
      refPrevious = _ref5.refPrevious;

  var _useState = useState({
    left: null,
    width: null,
    animate: false,
    withTransition: true
  }),
      _useState$ = _useState[0],
      left = _useState$.left,
      width = _useState$.width,
      animate = _useState$.animate,
      withTransition = _useState$.withTransition,
      setPosition = _useState[1];

  var leftRef = useVariable(left);
  var widthRef = useVariable(width);

  var setLinePosition = function setLinePosition(withTransition) {
    if (withTransition === void 0) {
      withTransition = true;
    }

    if (refCurrent && refCurrentInner) {
      var leftNew = refCurrent && refCurrentInner ? refCurrentInner.offsetLeft : null;
      var widthNew = refCurrent && refCurrentInner ? refCurrentInner.clientWidth : null;

      if (leftRef.current !== leftNew || widthRef.current !== widthNew) {
        leftRef.current = leftNew;
        widthRef.current = widthNew;
        setPosition({
          left: leftNew,
          width: widthNew,
          animate: refCurrent && !refPrevious,
          withTransition: withTransition
        });
      }
    }
  };

  useEffect(function () {
    setLinePosition(true);
    onLineReset.current = setLinePosition;
  }, [refCurrent, refPrevious, refCurrentInner]);
  return /*#__PURE__*/React.createElement(Line, {
    $animate: animate,
    $withTransition: withTransition,
    $left: left,
    $width: width
  });
};

export default TabLine;